import React, {FC, useEffect, useState} from "react";
import ReactMarkdown from "react-markdown";
import {useHistory} from "react-router";
import {LeftOutlined} from "@ant-design/icons";
import styles from "./assistantApp.less";

const AssistantChangelog: FC = () => {
    const history = useHistory();
    const [md, setMd] = useState("");

    useEffect(() => {
        fetch("../../CHANGELOG_CUSTOMERS_AssistantApp.md")
            .then(async (response) => {
                setMd(await response.text());
            })
            .catch(() => undefined);
    }, []);

    return (
        <div>
            <div style={{display: "flex", alignItems: "center", gap: 8, marginBottom: 16}}>
                <LeftOutlined
                    onClick={() => history.goBack()}
                    style={{fontSize: 18, cursor: "pointer", color: "var(--aa-text-primary)"}}
                />
                <div className={styles.assistantSectionTitle} style={{marginBottom: 0}}>
                    {"Neuigkeiten"}
                </div>
            </div>
            <div className={styles.assistantChangelogContent}>
                <ReactMarkdown>{md}</ReactMarkdown>
            </div>
        </div>
    );
};

export default AssistantChangelog;
